import isArray from 'lodash-es/isArray';
import isPlainObject from 'lodash-es/isPlainObject';
import { InvalidSchema } from '../errors';

export type Schema<O> = (input: any) => O;

export namespace Schema {
  export function object<Outputs extends { [key: string]: any }>(
    keys: { [K in keyof Outputs]: Schema<Outputs[K]> }
  ): Schema<Outputs> {
    return (input: any) => {
      if (!isPlainObject(input)) {
        throw new InvalidSchema('Expected a plain object');
      }
      const values = Object.keys(keys).reduce(
        (acc, key) => {
          const mapper = keys[key];
          acc[key] = mapper(input[key]);
          return acc;
        },
        {} as any
      );
      return values;
    };
  }

  export function undefinedOr<O>(schem: Schema<O>): Schema<O | undefined> {
    return (input: any) => {
      if (input === undefined) {
        return undefined;
      }
      return schem(input);
    };
  }

  export function array<O>(schem: Schema<O>): Schema<Array<O>> {
    return (input: any) => {
      if (!isArray(input)) {
        throw new InvalidSchema('Expected an array');
      }
      return input.map(schem);
    };
  }

  export function stringKeyedObject<K extends string, V>(valSchem: Schema<V>): Schema<{ [L in K]: V }> {
    return (input: any) => {
      if (!isPlainObject(input)) {
        throw new InvalidSchema('Expected an object');
      }
      return Object.keys(input).reduce<{ [L in K]: V }>(
        (acc, key) => {
          acc[key] = valSchem(input[key]);
          return acc;
        },
        {} as any
      );
    };
  }

  export const validate = <O>(schem: Schema<O>, input: any) => schem(input);
}



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/util/Schema.ts